import PropTypes from "prop-types";
import React from "react";
import Spinner from "react-spinner-material";

const MigrationCalendar = (props) => {
  const {
    state,
    migrationMonths,
    migrationDays,
    isGettingMigrationDays,
    handleChange2,
    found,
    handleChange,
  } = props;
  return (
    <div className="demo-calendar">
      <div className="form-selected-demo">
        <select
          className="form-selec2-d"
          name="month"
          value={state.monthName}
          onChange={handleChange2}
        >
          <option value="" disabled selected>
            Choose month
          </option>
          {migrationMonths &&
            migrationMonths.map((m) => (
              <option key={m.monthYear} value={m.monthYear} data={m.m}>
                {m.month}, {m.year}
              </option>
            ))}
        </select>
      </div>
      {isGettingMigrationDays ? (
        <div>
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : (
        <div className="form-selected-demo">
          <select
            name="date"
            value={found === false ? "" : state.date}
            onChange={handleChange}
            className="form-selec2-d"
          >
            <option value="" disabled selected>
              Choose day
            </option>
            {migrationDays &&
              migrationDays.map((d) => (
                <option key={d.day} value={d.day}>
                  {d.date}
                </option>
              ))}
          </select>
        </div>
      )}
    </div>
  );
};

MigrationCalendar.propTypes = {
  found: PropTypes.bool,
  handleChange: PropTypes.any,
  handleChange2: PropTypes.any,
  isGettingMigrationDays: PropTypes.any,
  migrationDays: PropTypes.shape({
    map: PropTypes.func,
  }),
  migrationMonths: PropTypes.shape({
    map: PropTypes.func,
  }),
  state: PropTypes.shape({
    date: PropTypes.any,
    monthName: PropTypes.any,
  }),
};

export default MigrationCalendar;
